import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material';

export const MuiSearchIcon = styled(SearchIcon)(({ theme }) => ({
    color: theme.palette.grey[500],
    fontSize: theme.typography.h5.fontSize,
}));
